import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const phases = gsap.utils.toArray(".method-cta__phase");

gsap.from(phases, {
    opacity: 0,
    y: 40,
    duration: 1,
    ease: "power2.out",
    stagger: 0.15,
    scrollTrigger: {
        trigger: ".method-cta__layout",
        start: "top 80%",
        toggleActions: "play none none none",
    },
});
